export enum EndOfDayHistoricalFieldsEnum {
	Status = 'Status',
	BankDepositCashAmount = 'BankDepositCashAmount',
	BankDepositChecksAmount = 'BankDepositChecksAmount'
}